<template>
  <div :class="`${$options.name}`">
    <div
      v-show="isLoading"
      :class="[`${$options.name}__container`, 'tw:justify-center tw:items-center']"
      :style="!$slots.default && { background: 'none' }"
      data-testid="edrone-loader"
    >
      <img
        v-show="isLoading"
        :class="`${$options.name}__img`"
        alt="Loading"
        src="https://d3vhsxl1pwzf0p.cloudfront.net/marketingmachine/edrone_loader.gif"
      />
    </div>
    <!-- @slot Content to be displayed after loading is complete. The component displays this content when isLoading has a value of false. -->
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneLoading",
  props: {
    /**
     * Determines whether the component should display a loading animation.
     */
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss">
$image-size: 60px;

.EdroneLoading {
  position: relative;
  min-width: 88px;
  min-height: 88px;

  &__container {
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 10;
  }
  &__img {
    width: 88px;
    height: 88px;
    padding: 11px;
    background: #fafafa;
    border: 1px solid #f2f2f2;
    border-radius: 50%;
  }
}
</style>
